import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import user from '../../assets/user.png';
function ReviewItem({ data, NombreAvis, MeanRating }) {
  const dateString = data.createdAt;
  const dateObj = new Date(dateString);

  // Options de formatage pour afficher la date en français
  const options = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };

  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleTouchStart = () => {
    setIsHovered(true);
  };

  const handleTouchEnd = () => {
    setIsHovered(false);
  };

  // Fonction pour obtenir la date formatée
  const formattedDate = dateObj.toLocaleDateString('fr-FR', options);
  return (
    <Link to={'#'}>
      <div
        className={` w-100 d-md-block w-md-75 my-div ${isHovered ? 'hovered' : ''}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <div class="d-flex">
          <div class="p-2 flex-fill" style={{ width: '270px' }}>
            <img src={data.profile_url || user} alt="" width={'40px'} />
            <div>
              <Stack spacing={1} className="mb-3">
                <Rating name="size-large" value={data.rating} size="medium" readOnly />
              </Stack>
              <small className="text-muted">{formattedDate}</small>
            </div>
            {/* <p className="text-muted">34 avis. 3.0</p> */}
          </div>
          <div class="p-2 flex-fill text-muted">
            <h4>
              {' '}
              {data.UserProfile.firstName} {data.UserProfile.lastName}
            </h4>
            <p>{data.content}</p>
          </div>
          <div class="p-2 flex-fill">
            <div class="logo ms-auto img-fluid">
              <img
                class=""
                src={data.Vehicle.principalPhotos || user}
                alt="Annonce voiture"
                height="80"
                width="100"
                style={{ borderRadius: '0.5rem' }}
              />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default ReviewItem;
